import React, { useContext } from "react";
import { LocationContext } from "./context";

const LocationListRefresh = () => {
    const { refreshLocations } = useContext(LocationContext);

    return (
        <span className="gp-locations-list-refresh" onClick={refreshLocations}>
            Refresh Data
        </span>
    );
};

export default LocationListRefresh;
